/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Submit_Content_Open_FormInputs */

const en_directory_submit_content_open_form = /** @type {(inputs: Directory_Submit_Content_Open_FormInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open form`)
};

const zh_directory_submit_content_open_form = /** @type {(inputs: Directory_Submit_Content_Open_FormInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`打开表单`)
};

/**
* | output |
* | --- |
* | "Open form" |
*
* @param {Directory_Submit_Content_Open_FormInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_content_open_form = /** @type {((inputs?: Directory_Submit_Content_Open_FormInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Content_Open_FormInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_content_open_form(inputs)
	return zh_directory_submit_content_open_form(inputs)
});
export { directory_submit_content_open_form as "directory.submit.content.open_form" }